import { render, staticRenderFns } from "./Clutches.vue?vue&type=template&id=32786944&"
import script from "./Clutches.vue?vue&type=script&lang=js&"
export * from "./Clutches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports